import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const HeroRotatingText = ({ words = [] }) => {
  const [index, setIndex] = useState(0);
  const [shouldAnimate, setShouldAnimate] = useState(true);

  useEffect(() => {
    // Check for reduced motion preference
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setShouldAnimate(!mediaQuery.matches);

    const handleChange = () => {
      setShouldAnimate(!mediaQuery.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    if (!shouldAnimate || words.length <= 1) return;

    const interval = setInterval(() => {
      setIndex((current) => (current + 1) % words.length);
    }, 2600);

    return () => clearInterval(interval);
  }, [words.length, shouldAnimate]);

  if (!shouldAnimate) {
    return <span className="text-gradient">{words[0] || ''}</span>;
  }

  return (
    <span className="inline-block relative" style={{ minWidth: '200px' }}>
      <AnimatePresence mode="wait">
        <motion.span
          key={index}
          initial={{ opacity: 0, y: 10, filter: 'blur(4px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          exit={{ opacity: 0, y: -10, filter: 'blur(4px)' }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="block"
          style={{
            background: 'linear-gradient(135deg, #E8A0B8, #F4C2D4)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          {words[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

export default HeroRotatingText;
